import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-zinc-800/80 py-5"
      data-testid="tech-marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">
              {item}
            </span>
            <span className="h-1 w-1 rounded-full bg-volt/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
